import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { addTermsCondition, getTermsCondition } from "../../../api";
import { snackActions } from "../../../helpers/SnackUtilsConfigurator";


const TermsCondition = () => {
  const [bodyText, setBodyText] = useState("");
  const {
    data: termsData,
  } = useQuery("terms", getTermsCondition);

  const {
    mutateAsync: addTermsConditonAPI,
    isLoading: isAddingTerms,
  } = useMutation("add-terms", addTermsCondition);

  useEffect(() => {
    if (termsData) {
      setBodyText(termsData.data?.description);
    }
  }, [termsData]);

  const handleSubmit = async () => {
    let bodyParams = {
      description: bodyText
    }
    let response = await addTermsConditonAPI(bodyParams);
    if (response?.status) {
      snackActions.success(response?.message ?? "Privacy & Policy Updated Successfully!");
    } else {
      snackActions.error(response?.message ?? "Something went wrong!");
    }

  }

  return (
    <div>
      <div className="card mb-5 mb-xl-10 p-14">
        <ReactQuill
          theme="snow"
          placeholder="Write something..."
          modules={TermsCondition.modules}
          formats={TermsCondition.formats}
          style={{ height: "50vh" }}
          value={bodyText}
          onChange={(e) => setBodyText(e)}
        />
        <div className="d-flex justify-content-end">
          <Button variant="primary" style={{ width: "100px", marginTop: "50px" }} onClick={handleSubmit}  disabled={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "")} color={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "") ? "disabled" : "success"}>{isAddingTerms ? "Loading." : "Submit"}</Button>{' '}
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;


TermsCondition.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [{ color: [] }],
  ],
};
TermsCondition.formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
];